import React, { useEffect, useState } from "react";
  
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PortraitIcon from '@mui/icons-material/Portrait';
import PersonIcon from '@mui/icons-material/Person';  
import { Link } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import { baseURL } from "../../constants/url";
 
const ProfileInformation = () => {
  const [profile, setProfile] = useState(null);
    const [error, setError] = useState(null); 

     document.querySelectorAll("input").forEach((input) => {
        if (input.value.trim() !== "") {
            input.classList.add("filled");
        }

        input.addEventListener("input", () => {
            if (input.value.trim() !== "") {
            input.classList.add("filled");
            } else {
            input.classList.remove("filled");
            }
        });
        });

    useEffect(() => {
        
        const fetchProfile = async () => {
            try {
                // Retrieve token from localStorage
                const token = localStorage.getItem("authToken");

                // If no token, show error and exit
                if (!token) {
                    setError("No authentication token found. Please login again.");
                    return;
                }

                // Make the API request using the token
                const response = await axios.get(`${baseURL}common/profile/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    responseType: 'json',
                });

                // Log the API response
                console.log('API Response with data:', response.data);
                setProfile(response.data);   

            } catch (error) {
                console.error("Failed to fetch profile data:", error);

                // Check for HTML response
                if (error.response && error.response.headers['content-type'].includes('html')) {
                    console.log('Received HTML response, possibly an error page');
                }

                // Set error state
                setError("Failed to fetch profile data. Please try again later.");
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        console.log('Updated Profile:', profile);
    }, [profile]);


  return (
    <>
       
       {/* <div className="container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 mb_30 "> */}
                        <div className="profile_box">
                            <div className="profile-card">
                                <div className="profile_card_img">
                                    <div className="profile-photo">
                                        <img 
                                            src={profile?.profile_picture || require("../../assets/images/review_user.jpg")} 
                                            alt="Profile" 
                                        />
                                    </div>
                                    {profile ? (
                                        <h5 className="mt_20">{profile.first_name} {profile.last_name}</h5>
                                    ) : (
                                        <h5 className="mt_20">Loading...</h5>
                                    )} 
                                    {/* <span className="title">Product Developer</span> */}
                                    <h6 className="mt_20">Phone Number</h6>
                                    <p>{profile?.phone_number || "N/A"}</p>
                                </div>

                                <div className="profile-details">
                                    <div className="profile-header">
                                        <div className="widthFull">
                                            <div className="update_profile_btn widthFull pb_15 d_flex align_center justify_sp_between">
                                                <h5>{profile?.first_name} {profile?.last_name || "N/A"} <span className="badge">Prime</span></h5>
                                                <Link to="/updateprofile" className="update_proifile_btn" type="submit"><EditIcon /> Update Profile</Link>
                                            </div>
                                            {/* <span className="title">Product Developer</span> */}
                                            {/* <div className="location">New Delhi</div> */}
                                        </div> 
                                    </div>

                                    {/* <div className="rating d_flex align_center gap_5 ">
                                        <span className="badge">4.5</span>
                                        <span className="stars"><StarIcon /> <StarIcon /> <StarIcon /> <StarIcon /> <StarHalfIcon /></span>
                                    </div> */}

                                    <div className="border_bottom"></div>

                                    <div className="info">
                                        <h4><PortraitIcon className="common_color" /> First Name</h4>
                                        <p className="pl_30">{profile?.first_name || "N/A"}</p>
                                        <h4><PersonIcon className="common_color" /> Last Name</h4>
                                        <p className="pl_30">{profile?.last_name || "N/A"}</p>
                                        <h4><PhoneIphoneIcon className="common_color" /> Phone Number</h4>
                                        <p className="pl_30">{profile?.phone_number || "N/A"}</p>
                                        <h4><MailOutlineIcon className="common_color" /> Email</h4>
                                        <p className="pl_30">{profile?.email || "N/A"}</p>
                                         
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div>
        </div> */}
    </>
  );
};

export default ProfileInformation;
